import React, { useCallback, useEffect, useRef, useState } from "react";
// import "./App.css";
import ImageToolRenderingFromDataProps from "./ImageToolPostPreviewForAgency";
import {
  getAddress,
  getAgencyLogoUrl,
  getCdnImageUrl,
  getFontUrl,
} from "../../utils/helpers/common";
import { CommonUtils } from "../../utils/helpers/common.utils";
import axiosInstance from "../../utils/api/Axios";
import FabricCanvasMemoryReference from "../../utils/FabricCanvasMemoryReference";
import DesignTemplateCanvasComponent from "./DesignTemplateCanvasComponent";
import DesignCanvasComponent from "./DesignCanvasComponent";

const normalFontsList = [
  {
    _id: {
      $oid: "6a474e61b67b9fd13c357f89",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-black-1783058017554-bbcb92b1-4fff-4b61-b97e-6bcf3b7ffcd6.woff2",
    postscript_name: "ArchivoExpanded-Black",
  },
  {
    _id: {
      $oid: "6a474e62b67b9fd13c357f91",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-bold-1783058018186-9c583690-27ee-4d2b-a572-ead2325143e4.woff2",
    postscript_name: "ArchivoExpanded-Bold",
  },
  {
    _id: {
      $oid: "6a474e63b67b9fd13c357f99",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-extrabold-1783058018857-1bd29c58-f595-4e8f-9376-a1742a265e6a.woff2",
    postscript_name: "ArchivoExpanded-ExtraBold",
  },
  {
    _id: {
      $oid: "6a474e63b67b9fd13c357fa1",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-extralight-1783058019564-fb52f4d4-a13d-4f70-ad82-9ff8dcb4d515.woff2",
    postscript_name: "ArchivoExpanded-ExtraLight",
  },
  {
    _id: {
      $oid: "6a474e65b67b9fd13c357fad",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-light-1783058020809-5f6960b7-122f-484b-8d41-c7881577d562.woff2",
    postscript_name: "ArchivoExpanded-Light",
  },
  {
    _id: {
      $oid: "6a474e65b67b9fd13c357fb5",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-medium-1783058021505-af29f2ca-98c1-473b-9d08-a54ea47920e6.woff2",
    postscript_name: "ArchivoExpanded-Medium",
  },
  {
    _id: {
      $oid: "6a474e66b67b9fd13c357fbd",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-regular-1783058022223-81416ca3-314e-415d-8f6f-8a010724f202.woff2",
    postscript_name: "ArchivoExpanded-Regular",
  },
  {
    _id: {
      $oid: "6a474e66b67b9fd13c357fc1",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-semibold-1783058022541-8a6b48b0-8341-4e78-b932-1f0ea2de845b.woff2",
    postscript_name: "ArchivoExpanded-SemiBold",
  },
  {
    _id: {
      $oid: "6a474e67b67b9fd13c357fc9",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-thin-1783058023255-99da1a7b-7333-4892-960c-1f7e3b760007.woff2",
    postscript_name: "ArchivoExpanded-Thin",
  },
];

const italicFontsList = [
  {
    _id: {
      $oid: "6a474e62b67b9fd13c357f8d",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-blackitalic-1783058017858-d7d79723-d869-4e6c-bf48-4bacd81912c4.woff2",
    postscript_name: "ArchivoExpanded-BlackItalic",
  },
  {
    _id: {
      $oid: "6a474e62b67b9fd13c357f95",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-bolditalic-1783058018499-2e2e2314-3fe1-4305-864b-1ae86d8e9cd8.woff2",
    postscript_name: "ArchivoExpanded-BoldItalic",
  },
  {
    _id: {
      $oid: "6a474e63b67b9fd13c357f9d",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-extrabolditalic-1783058019185-d6171388-6c05-43c9-9e33-e02117e8074e.woff2",
    postscript_name: "ArchivoExpanded-ExtraBoldItalic",
  },
  {
    _id: {
      $oid: "6a474e64b67b9fd13c357fa5",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-extralightitalic-1783058019992-024d1cf9-60e8-424b-b52e-9447cbd23e51.woff2",
    postscript_name: "ArchivoExpanded-ExtraLightItalic",
  },
  {
    _id: {
      $oid: "6a474e64b67b9fd13c357fa9",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-italic-1783058020395-c9330843-ce2b-4e70-9c80-cec7f92753d2.woff2",
    postscript_name: "ArchivoExpanded-Italic",
  },
  {
    _id: {
      $oid: "6a474e65b67b9fd13c357fb1",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-lightitalic-1783058021164-f0670c46-3b3e-4c86-b7b1-119af3c0b214.woff2",
    postscript_name: "ArchivoExpanded-LightItalic",
  },
  {
    _id: {
      $oid: "6a474e66b67b9fd13c357fb9",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-mediumitalic-1783058021859-4b7fceeb-0813-4396-9325-99a3b70716b9.woff2",
    postscript_name: "ArchivoExpanded-MediumItalic",
  },
  {
    _id: {
      $oid: "6a474e67b67b9fd13c357fc5",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-semibolditalic-1783058022878-401c5b79-f527-4d8c-86e0-1379bfdb5444.woff2",
    postscript_name: "ArchivoExpanded-SemiBoldItalic",
  },
  {
    _id: {
      $oid: "6a474e67b67b9fd13c357fcd",
    },
    font_url:
      "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/system-fonts/6a474e61b67b9fd13c357f85/archivo-expanded-thinitalic-1783058023569-326a9978-034b-4fd6-b00c-6060afe7db32.woff2",
    postscript_name: "ArchivoExpanded-ThinItalic",
  },
];

const allFontsList = [...normalFontsList, ...italicFontsList];

/**
 * Svg template paths
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/design-templates/01-general-purpose-template.svg
 */

/**
 * Agency logo links from cdn
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/raywhite-agency-logo.png
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/harcourts-3-color-logo.png
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/heritage-logo-3-color-logo.png
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/remax-logo.png
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/top-estates-3-color-logo.png
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/greenview-2-color-logo.png
 */

/**
 * Sample agent profile images links from cdn
 * General agent images
 *
 * Agent image
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-male-agent-profile-image.jpg
 *
 * Co-agent image
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-female-agent-profile-image.jpg
 *
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/slwilson.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/sarah-wilson-profile-photo.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/harry-potter-profile-image.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/rose-potter-profile-image.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/john-weak-profile-image.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/eric-pillai-profile-image.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/anna-belle-profile-image.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/150X200-image.avif
 */

/**
 * General property image
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/house-mage-compressed-06.jpg
 *
 * Sample property images links from cdn
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/property-image-1.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/property-image-2.webp
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/marvin-meyer-bfOQSDwEFg4-unsplash.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/dillon-kydd-2keCPb73aQY-unsplash.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/1000X750-image.webp
 */

/**
 * Sample addresses
 * Au:24 Harbour View Drive, Bondi NSW 2026
 * Nz:18 Kowhai Street, Remuera, Auckland 1050
 *
 *
 * Sample mobile numbers
 * AU: 0412 345 678 and 0435 987 654
 * NZ: 021 123 4567 and 027 987 6543
 */

let sampleDesignData = {
  template_url: {
    url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/design-templates/01-general-purpose-template.svg",
    load: false,
  },
  output_image_file_path: {
    url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
    load: false,
  },
  output_image_relative_path: {
    url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
    load: false,
  },
  output_source_file_path: {
    url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-image-templates/24-06-2025/updated-template-7cdf23c2-b194-11f0-aa94-7b7e22fd0c48-1761391175676.ai",
    load: false,
  },
  property_stage: "COMING SOON - FOR RENT",
  property_address: "12 Chifley Drive, Preston, Victoria, 3072",
  agency_logo: {
    url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/raywhite-agency-logo.png",
    load: true,
  },
  design_main_image: {
    url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/house-mage-compressed-06.jpg",
    load: true,
  },

  design_images: [
    {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/marvin-meyer-bfOQSDwEFg4-unsplash.jpg",
      load: true,
      index: 0,
      image_type: "property_image",
    },
    {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/1000X750-image.webp",
      load: true,
      index: 1,
      image_type: "property_image",
    },
  ],

  /**
   * Property price types
   * price-range
   * price-per-week
   * price-per-month
   * contact-agent
   * offer-above-xyz-price
   * content-agent-for-sell
   * price-guide-xyz-price
   * eoi
   */
  property_price_type: "price-per-week",
  start_price: "$0",
  end_price: "$0",
  property_price: "$800",
  base_color_primary: { r: 255, g: 0, b: 0, hex: "#FFE512" },
  base_color_secondary: { r: 255, g: 255, b: 255, hex: "#5A5A5A" },
  text_color_primary: { r: 255, g: 255, b: 255, hex: "#5A5A5A" },
  text_color_secondary: { r: 255, g: 0, b: 0, hex: "#FFFFFF" },
  agent_name: "Ethan Cooper",
  agent_email: "new.agentemail@domain.com",
  agent_phone: "0400777888",
  agent_profile_image_path: {
    url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-male-agent-profile-image.jpg",
    load: true,
  },
  // is_co_agent_available: false,
  co_agent_profile_image_path: {
    url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-female-agent-profile-image.jpg",
    load: true,
  },

  /**
   * If co-agent not available
   */
  // co_agent_profile_image_path: null,

  co_agent_name: "Grace Harrison",
  co_agent_email: "new.coagentemail@domain.com",
  co_agent_phone: "0434509348",
  bathroom_count: 9,
  bedroom_count: 10,
  living_count: "7",
  parking_count: 8,
  property_area: "1020 m²",
  eoi_datetime: "26.09.2025, 06:00 PM",
  post_type: "image_post",
  design_template_id: "68fcaf8010a67d04555eb0da",
  agency_trading_name: "Greenview Real Estate",
  agency_website: "website.com.au",
  office_contact: "website.com.au",
  office_email: "info@website.com.au",
  agency_address: "123 Main Street, Anytown, Australia",
  /**
   * Datetime info field
   * We can add following dates for this setup here
   * Open home date
   * Auction date
   * Property availability date for sale or rent properties
   */
  datetime_info: "AVAILABLE - 13 DEC 2026",
  bond_price: "$2,500",

  fonts: {
    title: {
      font_300: {
        postscript_name: "ArchivoExpanded-Light",
        loaded: false,
        error: false,
      },
      font_300_italic: {
        postscript_name: "ArchivoExpanded-LightItalic",
        loaded: false,
        error: false,
      },
      font_400: {
        postscript_name: "ArchivoExpanded-Regular",
        loaded: false,
        error: false,
      },
      font_400_italic: {
        postscript_name: "ArchivoExpanded-Italic",
        loaded: false,
        error: false,
      },
      font_500: {
        postscript_name: "ArchivoExpanded-Medium",
        loaded: false,
        error: false,
      },
      font_500_italic: {
        postscript_name: "ArchivoExpanded-MediumItalic",
        loaded: false,
        error: false,
      },
      font_600: {
        postscript_name: "ArchivoExpanded-SemiBold",
        loaded: false,
        error: false,
      },
      font_600_italic: {
        postscript_name: "ArchivoExpanded-SemiBoldItalic",
        loaded: false,
        error: false,
      },
      font_700: {
        postscript_name: "ArchivoExpanded-Bold",
        loaded: false,
        error: false,
      },
      font_700_italic: {
        postscript_name: "ArchivoExpanded-BoldItalic",
        loaded: false,
        error: false,
      },
      font_800: {
        postscript_name: "ArchivoExpanded-ExtraBold",
        loaded: false,
        error: false,
      },
      font_800_italic: {
        postscript_name: "ArchivoExpanded-ExtraBoldItalic",
        loaded: false,
        error: false,
      },
      font_900: {
        postscript_name: "ArchivoExpanded-Black",
        loaded: false,
        error: false,
      },
      font_900_italic: {
        postscript_name: "ArchivoExpanded-BlackItalic",
        loaded: false,
        error: false,
      },
    },

    subtitle: {
      font_300: {
        postscript_name: "ArchivoExpanded-Light",
        loaded: false,
        error: false,
      },
      font_300_italic: {
        postscript_name: "ArchivoExpanded-LightItalic",
        loaded: false,
        error: false,
      },
      font_400: {
        postscript_name: "ArchivoExpanded-Regular",
        loaded: false,
        error: false,
      },
      font_400_italic: {
        postscript_name: "ArchivoExpanded-Italic",
        loaded: false,
        error: false,
      },
      font_500: {
        postscript_name: "ArchivoExpanded-Medium",
        loaded: false,
        error: false,
      },
      font_500_italic: {
        postscript_name: "ArchivoExpanded-MediumItalic",
        loaded: false,
        error: false,
      },
      font_600: {
        postscript_name: "ArchivoExpanded-SemiBold",
        loaded: false,
        error: false,
      },
      font_600_italic: {
        postscript_name: "ArchivoExpanded-SemiBoldItalic",
        loaded: false,
        error: false,
      },
      font_700: {
        postscript_name: "ArchivoExpanded-Bold",
        loaded: false,
        error: false,
      },
      font_700_italic: {
        postscript_name: "ArchivoExpanded-BoldItalic",
        loaded: false,
        error: false,
      },
      font_800: {
        postscript_name: "ArchivoExpanded-ExtraBold",
        loaded: false,
        error: false,
      },
      font_800_italic: {
        postscript_name: "ArchivoExpanded-ExtraBoldItalic",
        loaded: false,
        error: false,
      },
      font_900: {
        postscript_name: "ArchivoExpanded-Black",
        loaded: false,
        error: false,
      },
      font_900_italic: {
        postscript_name: "ArchivoExpanded-BlackItalic",
        loaded: false,
        error: false,
      },
    },

    body: {
      font_300: {
        postscript_name: "ArchivoExpanded-Light",
        loaded: false,
        error: false,
      },
      font_300_italic: {
        postscript_name: "ArchivoExpanded-LightItalic",
        loaded: false,
        error: false,
      },
      font_400: {
        postscript_name: "ArchivoExpanded-Regular",
        loaded: false,
        error: false,
      },
      font_400_italic: {
        postscript_name: "ArchivoExpanded-Italic",
        loaded: false,
        error: false,
      },
      font_500: {
        postscript_name: "ArchivoExpanded-Medium",
        loaded: false,
        error: false,
      },
      font_500_italic: {
        postscript_name: "ArchivoExpanded-MediumItalic",
        loaded: false,
        error: false,
      },
      font_600: {
        postscript_name: "ArchivoExpanded-SemiBold",
        loaded: false,
        error: false,
      },
      font_600_italic: {
        postscript_name: "ArchivoExpanded-SemiBoldItalic",
        loaded: false,
        error: false,
      },
      font_700: {
        postscript_name: "ArchivoExpanded-Bold",
        loaded: false,
        error: false,
      },
      font_700_italic: {
        postscript_name: "ArchivoExpanded-BoldItalic",
        loaded: false,
        error: false,
      },
      font_800: {
        postscript_name: "ArchivoExpanded-ExtraBold",
        loaded: false,
        error: false,
      },
      font_800_italic: {
        postscript_name: "ArchivoExpanded-ExtraBoldItalic",
        loaded: false,
        error: false,
      },
      font_900: {
        postscript_name: "ArchivoExpanded-Black",
        loaded: false,
        error: false,
      },
      font_900_italic: {
        postscript_name: "ArchivoExpanded-BlackItalic",
        loaded: false,
        error: false,
      },
    },
  },
};

const getAvailableDate = () => {
  const date = new Date();
  date.setMonth(date.getMonth() + 1);

  const day = date.getDate();

  const month = date.toLocaleString("en-AU", { month: "short" }).toUpperCase();

  const year = date.getFullYear();

  return `AVAILABLE - ${day} ${month} ${year}`;
};

sampleDesignData.datetime_info = getAvailableDate();

// let updatedFontsData = sampleDesignData.fonts;

const getFontKeys = (fonts, postscriptName) => {
  const matches = [];

  for (const textType in fonts) {
    const textFonts = fonts[textType];

    for (const key in textFonts) {
      if (textFonts[key].postscript_name === postscriptName) {
        matches.push({
          text_type: textType,
          key,
        });
      }
    }
  }

  return matches;
};

/**
 * Normalizes a hex color string.
 * @param {string} color - The hex color string.
 * @returns {string|null} Normalized hex color in lowercase.
 */
function normalizeHexColor(color) {
  if (!color) return null;

  if (typeof color !== "string") {
    return color;
  }

  return color?.trim()?.toLowerCase();
}

let agencyColors = {
  text_primary: null,
  text_secondary: null,
  base_primary: null,
  base_secondary: null,
};

const getAgencyLogo = ({ agencyData, brandData, useAgencyOfficeLogo }) => {
  if (brandData && !useAgencyOfficeLogo) {
    // console.log("returned logo > brand");
    // debugger;
    return getAgencyLogoUrl(brandData?.brand_logo);
  }

  // debugger;

  // console.log("returned logo > agency");

  return getAgencyLogoUrl(agencyData?.profile_image_ref);
};

/**
 * Theme colors used while rendering the design.
 *
 * @typedef {Object} DesignThemeColors
 * @property {{hex: string}} base_color_primary - Primary background color.
 * @property {{hex: string}} base_color_secondary - Secondary background color.
 * @property {{hex: string}} text_color_primary - Primary text color.
 * @property {{hex: string}} text_color_secondary - Secondary text color.
 */

// /**
//  * Renders a post preview for the image tool utilizing agency branding and configuration data.
//  *
//  * @component
//  * @param {Object} props - Component properties.
//  * @param {import("../../@types/agency.data").AgencyData} props.agencyData - The agency configuration object containing branding, colors, and profile details.
//  * @param {DesignThemeColors} props.colorsData - The agency configuration object containing branding, colors, and profile details.
//  * @param {import("../../@types/brand.data").BrandData} props.brandData - The brand object containing branding, colors, and profile details.
//  * @param {boolean} props.useAgencyOfficeLogo - The agency configuration object containing branding, colors, and profile details.
//  * @returns {JSX.Element} The rendered post preview component.
//  *
//  * */

let oldProps = {
  agencyData: null,
  colorsData: null,
  brandData: null,
  useAgencyOfficeLogo: null,
  selectedFonts: null,
  receiveFontChanges: null,
  showMobileDrawer: null,
  mobileDrawerContainer: null,
  designTemplateData: null,
};

/**
 * @component
 * @param {Object} props - Component properties.
 * @param {import("../../@types/agency.data").AgencyData} props.agencyData
 * @param {import("../../@types/brand.data").BrandData} props.brandData
 * @param {boolean} props.useAgencyOfficeLogo
 * @param {any} [props.selectedFonts]
 * @param {import("../../@types/design.data").DesignData} [props.designDataFromParent]
 * @param {boolean} [props.receiveFontChanges]
 * @param {boolean} [props.showMobileDrawer]
 * @param {Number} [props.canvasWidth]
 * @param {Number} [props.canvasHeight]
 * @param {HTMLElement | null} [props.mobileDrawerContainer]
 * @param {import("../../@types/design.fonts").DesignTemplateAssets | null} [props.designTemplateAssets]
 * @returns {JSX.Element}
 */

const DesignPreviewRenderer = ({
  agencyData,
  brandData,
  useAgencyOfficeLogo,
  selectedFonts = null,
  receiveFontChanges = false,
  showMobileDrawer = false,
  mobileDrawerContainer = null,
  designStage,
  agencyFontsData,
  designDataFromParent,
  canvasWidth = 1080,
  canvasHeight = 1080,
  designTemplateAssets,
}) => {
  // console.log("Rerendered > DesignPreviewRenderer");
  // console.log("templateData", templateData);
  // console.log("agencyData: ", agencyData);
  // console.log("brandData: ", brandData);

  /**
   * Save the fabric.js canvas instance from the child component here
   */
  const [designData, setDesignData] = useState(designDataFromParent);

  const agencyColors = useRef({
    text_primary: null,
    text_secondary: null,
    base_primary: null,
    base_secondary: null,
  });

  const designCanvasRef = useRef(null);

  const [commonState, setCommonState] = useState({
    loading: true,
    reRenderDesign: false,
    fetchingFontsData: true,
    fontsToBeLoaded: [],
  });
  // console.log("App rendered");

  const [fontsState, setFontsState] = useState({
    loading: true,
    error: false,
  });

  let loadDesignTool = true;

  /**
   * Sequences of the conditions here is important and required
   */

  if (!agencyData?.profile_image_ref) {
    loadDesignTool = false;
  }

  if (!brandData?.brand_logo?._id) {
    loadDesignTool = false;
  }

  if (brandData && brandData?.brand_logo?._id) {
    loadDesignTool = true;
  }

  if (agencyData?.profile_image_ref) {
    loadDesignTool = true;
  }

  if (
    agencyData?.brand_id &&
    agencyData?.logo_preference == "brand_logo" &&
    !brandData?.brand_logo?._id
  ) {
    loadDesignTool = false;
    // debugger;
  }

  if (
    (agencyData?.brand_id &&
      agencyData?.logo_preference == "office_logo" &&
      !agencyData?.profile_image_ref) ||
    (useAgencyOfficeLogo && !agencyData?.profile_image_ref)
  ) {
    loadDesignTool = false;
  }

  // console.log("loadDesignTool: ", loadDesignTool);
  // console.log("useAgencyOfficeLogo: ", useAgencyOfficeLogo);

  const getSystemFontVariantsForMainFont = async ({ mainFontId }) => {
    try {
      const res = await axiosInstance.get(
        `/system-fonts/variants/for-main-font`,
        {
          params: {
            main_font_id: mainFontId,
          },
        },
      );

      return {
        success: true,
        data: res.data?.data?.docs,
      };
    } catch (err) {
      return {
        success: false,
        error:
          err?.response?.data?.message ||
          "Something went wrong while fetching brand settings!",
        data: err?.response?.data,
      };
    }
  };

  const getBrandFontVariantsForMainFont = async ({ mainFontId }) => {
    try {
      const res = await axiosInstance.get(
        `/brand-fonts/variants/for-main-font`,
        {
          params: {
            main_font_id: mainFontId,
          },
        },
      );

      return {
        success: true,
        data: res.data?.data?.docs,
      };
    } catch (err) {
      return {
        success: false,
        error:
          err?.response?.data?.message ||
          "Something went wrong while fetching brand settings!",
        data: err?.response?.data,
      };
    }
  };

  const getAgencyFontVariantsForMainFont = async ({ mainFontId }) => {
    try {
      const res = await axiosInstance.get(
        `/agency-fonts/variants/for-main-font`,
        {
          params: {
            main_font_id: mainFontId,
          },
        },
      );

      return {
        success: true,
        data: res.data?.data?.docs,
      };
    } catch (err) {
      return {
        success: false,
        error:
          err?.response?.data?.message ||
          "Something went wrong while fetching brand settings!",
        data: err?.response?.data,
      };
    }
  };

  /** @type {[import("../../@types/design.fonts").DesignTemplateAssets, React.Dispatch<React.SetStateAction<import("../../@types/design.fonts").DesignTemplateAssets>>]} */

  const [designTemplateData, setDesignTemplateData] =
    useState(designTemplateAssets);

  /**
   * Replaces a color with its corresponding agency color if it matches the template colors.
   * @returns {string} The replaced color or the original color if no match is found.
   */
  const replaceWithAgencyColors = ({ color, obj }) => {
    const normalizedColor = normalizeHexColor(color);
    const objId = obj?.id ?? "";

    /**
     * Sample ids with colors data
     * using-base-colors_color-base-primary_align-left_text-limit-22_width-480
     * color-text-primary_align-left_text-limit-22_width-480
     */

    let baseColorPrimary = false;
    let baseColorSecondary = false;
    let textColorPrimary = false;
    let textColorSecondary = false;

    if (objId.includes("color-text-primary")) {
      textColorPrimary = true;
    }

    if (objId.includes("color-text-secondary")) {
      textColorSecondary = true;
    }

    if (objId.includes("color-base-primary")) {
      baseColorPrimary = true;
    }

    if (objId.includes("color-base-secondary")) {
      baseColorSecondary = true;
    }

    if (baseColorPrimary) {
      return agencyColors.current.base_primary;
    }

    if (baseColorSecondary) {
      return agencyColors.current.base_secondary;
    }

    if (textColorPrimary) {
      return agencyColors.current.text_primary;
    }

    if (textColorSecondary) {
      return agencyColors.current.text_secondary;
    }
  };

  const setDesignCanvasInstance = useCallback((canvasInstance) => {
    designCanvasRef.current = canvasInstance;
  }, []);

  const updateColorsForCanvasObjects = () => {
    // setColor(event.target.value);

    // agencyColors.base_secondary = normalizeHexColor(event.target.value);
    // agencyColors.text_primary = normalizeHexColor(event.target.value);

    if (designCanvasRef?.current) {
      const allObjects = designCanvasRef?.current.getObjects();

      // console.log("Updating color: ");

      for (let _idx = 0; _idx < allObjects.length; _idx++) {
        const obj = allObjects[_idx];
        // console.log("layer id: ", obj.id);
        let disableColorUpdates = false;

        // console.log("Layer name: ", obj?.id);

        if (obj?.id?.includes("lock-color")) {
          disableColorUpdates = true;
        }

        if (!disableColorUpdates) {
          if (obj?.fill) {
            obj.set("fill", replaceWithAgencyColors({ color: obj.fill, obj }));
          }
          if (obj?.stroke) {
            obj.set(
              "stroke",
              replaceWithAgencyColors({ color: obj.stroke, obj }),
            );
          }
          if (obj?.textBackgroundColor) {
            obj.set(
              "textBackgroundColor",
              replaceWithAgencyColors({
                color: obj.textBackgroundColor,
                obj,
              }),
            );
          }
          if (obj?.backgroundColor) {
            obj.set(
              "backgroundColor",
              replaceWithAgencyColors({ color: obj.backgroundColor, obj }),
            );
          }
        }
      }

      designCanvasRef?.current.requestRenderAll();
    }
  };

  const preloadFonts = async ({ fonts, designFontsData }) => {
    const loadedFonts = [];

    setFontsState({
      loading: true,
      error: false,
    });

    setCommonState((prev) => ({
      ...prev,
      loading: true,
    }));

    let updatedFontsData = designFontsData;

    await Promise.all(
      fonts.map(async (font) => {
        let loadFont = font.load_font;

        console.log("preloadFonts > loadFont", loadFont);

        if (!loadFont) return;

        let fontKeys = getFontKeys(updatedFontsData, font.postscript_name);
        let fontUrl = getFontUrl(font);

        try {
          const fontFace = new FontFace(
            font.postscript_name,
            `url(${fontUrl})`,
          );

          await fontFace.load();
          document.fonts.add(fontFace);
          loadedFonts.push(fontFace);

          fontKeys.forEach(({ text_type, key }) => {
            updatedFontsData[text_type][key].loaded = true;
            updatedFontsData[text_type][key].error = false;
          });
        } catch (error) {
          console.error(`Failed to load font: ${font.postscript_name}`, error);

          fontKeys.forEach(({ text_type, key }) => {
            updatedFontsData[text_type][key].loaded = false;
            updatedFontsData[text_type][key].error = true;
          });
        }
      }),
    );

    setDesignData((prev) => ({
      ...prev,
      fonts: updatedFontsData,
    }));

    setFontsState({
      loading: false,
      error: false,
    });

    setCommonState((prev) => ({
      ...prev,
      loading: false,
    }));
  };

  const fetchFontsData = async () => {
    setCommonState((prev) => ({
      ...prev,
      fetchingFontsData: true,
      loading: true,
    }));

    let isBrandAgency = false;
    if (agencyData?.brand_id) isBrandAgency = true;

    let settingsData = null;
    if (isBrandAgency) {
      settingsData = brandData?.settings;
    } else settingsData = agencyData?.settings;

    let titleFont = settingsData?.title_fonts;
    let subtitleFont = settingsData?.subtitle_fonts;
    let bodyFont = settingsData?.body_text_fonts;

    let titleFontSelectedFrom = settingsData?.title_fonts_selected_from;
    let subtitleFontSelectedFrom = settingsData?.subtitle_fonts_selected_from;
    let bodyFontSelectedFrom = settingsData?.body_text_fonts_selected_from;

    // let fontsResults = await Promise.all(fontsPromises.map((task) => task()));

    let titleFonts = [];
    let subtitleFonts = [];
    let bodyFonts = [];

    // for (const item of fontsResults) {
    //   if (item.fontVariant === "title_font") titleFonts.push(item.fonts);
    //   if (item.fontVariant === "subtitle_font") subtitleFonts.push(item.fonts);
    //   if (item.fontVariant === "body_font") bodyFonts.push(item.fonts);
    // }

    titleFonts = titleFonts.flat();
    subtitleFonts = subtitleFonts.flat();
    bodyFonts = bodyFonts.flat();

    function uniqueById(arr) {
      const result = [];
      const seen = new Set();
      for (const item of arr) {
        if (!seen.has(item._id)) {
          seen.add(item._id);
          result.push(item);
        }
      }
      return result;
    }

    if (titleFont == "design_default" || !titleFontSelectedFrom) {
      if (designTemplateAssets?.title_fonts) {
        titleFonts = titleFonts.concat(designTemplateAssets?.title_fonts);
      }
    }

    if (subtitleFont == "design_default" || !subtitleFontSelectedFrom) {
      if (designTemplateAssets?.subtitle_fonts) {
        subtitleFonts = subtitleFonts.concat(
          designTemplateAssets?.subtitle_fonts,
        );
      }
    }

    if (bodyFont == "design_default" || !bodyFontSelectedFrom) {
      if (designTemplateAssets?.body_fonts) {
        bodyFonts = bodyFonts.concat(designTemplateAssets?.body_fonts);
      }
    }

    let updatedTitleFonts = uniqueById(titleFonts);
    let updatedSubtitleFonts = uniqueById(subtitleFonts);
    let updatedBodyFonts = uniqueById(bodyFonts);

    let designFontsData = CommonUtils.cloneDeep(designDataFromParent.fonts);

    // if (templateData?._id == "6a8faa5bf81853413e121e11") {
    //   console.log("fetchFontsData > selected fonts", {
    //     titleFont,
    //     subtitleFont,
    //     bodyFont,
    //   });

    //   // debugger

    //   console.log(
    //     "fetchFontsData > before update >  designFontsData:",
    //     designFontsData,
    //   );
    //   console.log(
    //     "fetchFontsData > designTemplateAssets:",
    //     designTemplateAssets,
    //   );
    //   console.log(
    //     "fetchFontsData > subtitleFonts:",
    //     designTemplateAssets?.subtitle_fonts,
    //   );
    // }

    for (const [index, element] of updatedTitleFonts.entries()) {
      let weight = element.font_weight;
      let isItalic = element.is_italic;
      let fontKey = `font_${weight}`;

      let requiredTitleFontWeights = designTemplateAssets?.title_fonts ?? [];
      requiredTitleFontWeights = requiredTitleFontWeights.map((font) =>
        String(font?.font_weight ?? ""),
      );

      console.log("requiredTitleFontWeights", requiredTitleFontWeights);

      let loadFont = true;
      let weightIdentifier = String(weight);

      if (isItalic) {
        weightIdentifier = `${weight}_italic`;
        fontKey = `${fontKey}_italic`;
      }

      if (requiredTitleFontWeights.includes(weightIdentifier)) {
        loadFont = true;
      }

      updatedTitleFonts[index].load_font = loadFont;

      if (designFontsData.title?.[fontKey]) {
        designFontsData.title[fontKey] = {
          loaded: false,
          error: false,
          postscript_name: element.postscript_name,
          load_font: loadFont,
        };
      }
    }

    for (const [index, element] of updatedSubtitleFonts.entries()) {
      let weight = element.font_weight;
      let isItalic = element.is_italic;
      let fontKey = `font_${weight}`;

      // if (templateData?._id == "6a8faa5bf81853413e121e11") {
      //   console.log(
      //     "fetchFontsData > element.postscript_name:",
      //     element.postscript_name,
      //   );
      // }

      let requiredSubtitleFontWeights =
        designTemplateAssets?.subtitle_fonts ?? [];
      requiredSubtitleFontWeights = requiredSubtitleFontWeights.map((font) =>
        String(font?.font_weight ?? ""),
      );

      // if (templateData?._id == "6a8faa5bf81853413e121e11") {
      //   console.log(
      //     "fetchFontsData > requiredSubtitleFontWeights:",
      //     requiredSubtitleFontWeights,
      //   );
      // }

      let loadFont = true;
      let weightIdentifier = String(weight);

      if (isItalic) {
        weightIdentifier = `${weight}_italic`;
        fontKey = `${fontKey}_italic`;
      }

      if (requiredSubtitleFontWeights.includes(weightIdentifier)) {
        loadFont = true;
      }

      updatedSubtitleFonts[index].load_font = loadFont;

      if (designFontsData.subtitle?.[fontKey]) {
        designFontsData.subtitle[fontKey] = {
          loaded: false,
          error: false,
          postscript_name: element.postscript_name,
          load_font: loadFont,
        };

        // if (templateData?._id == "6a8faa5bf81853413e121e11") {
        //   console.log("fetchFontsData > updating font data:", {
        //     fontkey: fontKey,
        //     loaded: false,
        //     error: false,
        //     postscript_name: element.postscript_name,
        //     load_font: loadFont,
        //   });
        // }
      }
    }

    for (const [index, element] of updatedBodyFonts.entries()) {
      let weight = element.font_weight;
      let isItalic = element.is_italic;
      let fontKey = `font_${weight}`;

      if (isItalic) fontKey = `${fontKey}_italic`;

      let requiredBodyFontWeights = designTemplateAssets?.body_fonts ?? [];
      requiredBodyFontWeights = requiredBodyFontWeights.map((font) =>
        String(font?.font_weight ?? ""),
      );

      let loadFont = true;
      let weightIdentifier = String(weight);

      if (isItalic) {
        weightIdentifier = `${weight}_italic`;
        fontKey = `${fontKey}_italic`;
      }

      if (requiredBodyFontWeights.includes(weightIdentifier)) {
        loadFont = true;
      }

      updatedBodyFonts[index].load_font = loadFont;

      if (designFontsData.body?.[fontKey]) {
        designFontsData.body[fontKey] = {
          loaded: false,
          error: false,
          postscript_name: element.postscript_name,
          load_font: loadFont,
        };
      }
    }

    let allFonts = [
      ...updatedTitleFonts,
      ...updatedSubtitleFonts,
      ...updatedBodyFonts,
    ];

    allFonts = uniqueById(allFonts);

    // if (templateData?._id == "6a8faa5bf81853413e121e11") {
    //   console.log("fetchFontsData > allFonts:", allFonts);
    //   console.log("fetchFontsData > designFontsData:", designFontsData);
    // }

    setDesignData((prev) => ({
      ...prev,
      fonts: designFontsData,
    }));

    setCommonState((prev) => ({
      ...prev,
      fetchingFontsData: false,
      fontsToBeLoaded: allFonts,
      loading: true,
    }));

    preloadFonts({ fonts: allFonts, designFontsData });
  };

  const getColorsData = () => {
    const data = {
      base_color_primary: { hex: "" },
      base_color_secondary: { hex: "" },
      text_color_primary: { hex: "" },
      text_color_secondary: { hex: "" },
    };

    if (brandData && !useAgencyOfficeLogo) {
      // console.log("returned colors > brand");
      // debugger;
      data.base_color_primary.hex = brandData?.base_color_primary?.hex ?? "";
      data.base_color_secondary.hex =
        brandData?.base_color_secondary?.hex ?? "";
      data.text_color_primary.hex = brandData?.text_color_primary?.hex ?? "";
      data.text_color_secondary.hex =
        brandData?.text_color_secondary?.hex ?? "";

      return data;
    }

    // debugger;

    // console.log("returned colors > agency");

    data.base_color_primary.hex = agencyData?.base_color_primary?.hex ?? "";
    data.base_color_secondary.hex = agencyData?.base_color_secondary?.hex ?? "";
    data.text_color_primary.hex = agencyData?.text_color_primary?.hex ?? "";
    data.text_color_secondary.hex = agencyData?.text_color_secondary?.hex ?? "";

    return data;
  };

  // useEffect(() => {
  //   setCommonState({
  //     loading: true,
  //   });
  //   /**
  //    * Assign agency design colors to global variables
  //    */
  //   // agencyColors.text_primary = normalizeHexColor(
  //   //   sampleDesignData?.text_color_primary.hex,
  //   // );
  //   // agencyColors.text_secondary = normalizeHexColor(
  //   //   sampleDesignData?.text_color_secondary.hex,
  //   // );
  //   // agencyColors.base_primary = normalizeHexColor(
  //   //   sampleDesignData?.base_color_primary.hex,
  //   // );
  //   // agencyColors.base_secondary = normalizeHexColor(
  //   //   sampleDesignData?.base_color_secondary.hex,
  //   // );

  //   // console.log("App > agencyColors: ", agencyColors);

  //   preloadFonts(allFontsList);
  // }, [agencyData]);

  // useEffect(() => {
  //   agencyColors.current.base_primary = colorsData.base_color_primary.hex;
  //   agencyColors.current.base_secondary = colorsData.base_color_secondary.hex;
  //   agencyColors.current.text_primary = colorsData.text_color_primary.hex;
  //   agencyColors.current.text_secondary = colorsData.text_color_secondary.hex;

  //   // console.log("Updating colors");

  //   // console.log("agencyColors >> ", agencyColors.current);

  //   updateColorsForCanvasObjects();
  // }, [colorsData]);

  const reRenderDesignComponent = useCallback(() => {
    setCommonState({
      ...commonState,
      reRenderDesign: !commonState.reRenderDesign,
    });

    // console.log("Re rendered design");
  }, [commonState.reRenderDesign]);

  const processAgencyDataWithDelay = () => {
    if (!agencyData) return;

    const updatedColors = getColorsData();

    setDesignData((prev) => ({
      ...prev,
      agency_logo: {
        url: getAgencyLogo({
          agencyData,
          brandData,
          useAgencyOfficeLogo,
        }),
        load: true,
      },
      base_color_primary: {
        r: 255,
        g: 0,
        b: 0,
        hex: updatedColors.base_color_primary?.hex,
      },
      base_color_secondary: {
        r: 255,
        g: 255,
        b: 255,
        hex: updatedColors?.base_color_secondary?.hex,
      },
      text_color_primary: {
        r: 255,
        g: 255,
        b: 255,
        hex: updatedColors?.text_color_primary?.hex,
      },
      text_color_secondary: {
        r: 255,
        g: 0,
        b: 0,
        hex: updatedColors?.text_color_secondary?.hex,
      },
    }));

    fetchFontsData(); // ← This triggers font fetching
  };

  // useEffect(() => {
  //   const updatedColors = getColorsData();
  //   // console.log("re rendering useeffect >>");

  //   setDesignData((prev) => ({
  //     ...prev,
  //     agency_logo: {
  //       url: getAgencyLogo({
  //         agencyData,
  //         brandData,
  //         useAgencyOfficeLogo,
  //       }),
  //       load: true,
  //     },
  //     base_color_primary: {
  //       r: 255,
  //       g: 0,
  //       b: 0,
  //       hex: updatedColors.base_color_primary.hex,
  //     },
  //     base_color_secondary: {
  //       r: 255,
  //       g: 255,
  //       b: 255,
  //       hex: updatedColors?.base_color_secondary.hex,
  //     },
  //     text_color_primary: {
  //       r: 255,
  //       g: 255,
  //       b: 255,
  //       hex: updatedColors?.text_color_primary.hex,
  //     },
  //     text_color_secondary: {
  //       r: 255,
  //       g: 0,
  //       b: 0,
  //       hex: updatedColors?.text_color_secondary.hex,
  //     },
  //   }));

  //   // updateColorsForCanvasObjects();
  // }, [agencyData, brandData, useAgencyOfficeLogo]);

  useEffect(() => {
    if (!loadDesignTool) return;

    // let isAgencyDataSame = isValuesEqual(oldProps.agencyData, agencyData);
    // let isBrandDataSame = isValuesEqual(oldProps.brandData, brandData);
    // let isUseAgencyOfficeLogoSame = isValuesEqual(
    //   oldProps.useAgencyOfficeLogo,
    //   useAgencyOfficeLogo,
    // );
    // let isSelectedFontsSame = isValuesEqual(
    //   oldProps.selectedFonts,
    //   selectedFonts,
    // );
    // let isReceiveFontChangesSame = isValuesEqual(
    //   oldProps.receiveFontChanges,
    //   receiveFontChanges,
    // );
    // let isDesignTemplateDataSame = isValuesEqual(
    //   oldProps.designTemplateData,
    //   designTemplateData,
    // );

    // if (
    //   isAgencyDataSame &&
    //   isBrandDataSame &&
    //   isUseAgencyOfficeLogoSame &&
    //   isSelectedFontsSame &&
    //   isReceiveFontChangesSame &&
    //   isDesignTemplateDataSame
    // ) {
    //   return;
    // }

    // oldProps.agencyData = agencyData;
    // oldProps.brandData = brandData;
    // oldProps.selectedFonts = selectedFonts;
    // oldProps.useAgencyOfficeLogo = useAgencyOfficeLogo;
    // oldProps.designTemplateData = designTemplateData;
    // oldProps.receiveFontChanges = receiveFontChanges;

    // console.log("Loading fonts data");

    setCommonState((prev) => ({
      ...prev,
      fetchingFontsData: true,
      loading: true,
    }));

    if (designTemplateAssets) {
      setDesignTemplateData(designTemplateAssets);
    }

    const debounceTimer = setTimeout(() => {
      processAgencyDataWithDelay();
    }, 0);

    return () => {
      clearTimeout(debounceTimer);
      FabricCanvasMemoryReference.resetDesignColors();
    };
  }, [
    agencyData,
    brandData,
    useAgencyOfficeLogo,
    selectedFonts,
    receiveFontChanges,
    designTemplateData,
    designTemplateAssets,
    designDataFromParent,
  ]);

  // useEffect(() => {
  //   reRenderDesignComponent();
  //   // setCommonState({
  //   //   ...common
  //   // })
  //   // designDataRef.current.agency_logo.url =
  // }, [brandData, useAgencyOfficeLogo]);

  // console.log("isFontsLoading >>>", isFontsLoading);

  // if (commonState.loading) {
  //   return <p className="font-inter-400">Loading preview...</p>; // Or a spinner
  // }

  // if (!loadDesignTool) {
  //   return (
  //     <div className="right-column">
  //       <div className="grammar-section">
  //         <div className="preview-wrapper">
  //           <div className="preview-card">
  //             <div className="empty-preview-content">
  //               <img
  //                 src="/icons/pending-icon-2.png"
  //                 alt="Waiting Icon"
  //                 className="waiting-icon"
  //               />
  //               <p>Upload agency logo to generate the preview</p>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  if (commonState.fetchingFontsData) {
    return (
      <div className="image-tool-container">
        <div className="canvas-container is-loading">
          <div className="design-loader-overlay">
            <div className="design-loader-spinner" />
            <p className="design-loader-text">Downloading fonts data...</p>
          </div>
        </div>
      </div>
    );
  }

  if (fontsState.loading) {
    return (
      <div className="image-tool-container">
        <div className="canvas-container is-loading">
          <div className="design-loader-overlay">
            <div className="design-loader-spinner" />
            <p className="design-loader-text">Loading design fonts...</p>
          </div>
        </div>
      </div>
    );
  }

  // if (commonState.fetchingFontsData) {
  //   return (
  //     <div className="image-tool-container design-preview-loader">
  //       <div className="preview-header-row">
  //         <div className="section-title">Post preview</div>
  //       </div>
  //       <p className="section-desc right-grammer-desc">
  //         A live preview of your marketing content with your agency's branding
  //         applied
  //       </p>

  //       <div className="loading-container">
  //         <div className="spinner" />
  //       </div>
  //       <p
  //         className="font-inter-400 right-column text-subtitle"
  //         style={{
  //           fontSize: 14,
  //         }}
  //       >
  //         Downloading fonts data...
  //       </p>
  //     </div>
  //   ); // Or a spinner
  // }

  // if (fontsState.loading) {
  //   return (
  //     <div className="image-tool-container design-preview-loader">
  //       <div className="preview-header-row">
  //         <div className="section-title">Post preview</div>
  //       </div>
  //       <p className="section-desc right-grammer-desc">
  //         A live preview of your marketing content with your agency's branding
  //         applied
  //       </p>

  //       <div className="loading-container">
  //         <div className="spinner" />
  //       </div>

  //       <p
  //         className="font-inter-400 right-column text-subtitle"
  //         style={{
  //           fontSize: 14,
  //         }}
  //       >
  //         Loading design fonts...
  //       </p>
  //     </div>
  //   ); // Or a spinner
  // }

  // console.log("sampleDesignData: ", sampleDesignData);

  return (
    <>
      {/* <input
        type="color"
        // id={new Date().toISOString()}
        value={color}
        onChange={handleColorChange}
      />
      <span>{color}</span>

      <div
        style={{
          width: "40px",
          height: "40px",
          border: "1px solid #ccc",
          backgroundColor: color,
        }}
      /> */}

      {/* <ImageToolEditor
        imageData={sampleDesignData}
        setDesignCanvasInstance={setDesignCanvasInstance}
      /> */}
      <DesignCanvasComponent
        imageData={designData}
        setDesignCanvasInstance={setDesignCanvasInstance}
        canvasWidth={canvasWidth}
        canvasHeight={canvasHeight}
        reRenderDesign={useAgencyOfficeLogo}
        showMobileDrawer={showMobileDrawer}
        mobileDrawerContainer={mobileDrawerContainer}
      />
      {/* <ImageReplacerComponent /> */}
    </>
  );
};

export default React.memo(DesignPreviewRenderer);
